 
<!-- OrderList -->
  <template>
  <div class="order-list-page" v-cloak>
    <van-nav-bar left-arrow fixed title="订单" id="nav-bar" @click-left="onClickLeft">
    </van-nav-bar>

    <div class="tabs">
      <van-tabs v-model="active" title-active-color="#ff5000" title-inactive-color="#78849E" color="#ff5000" z-index="100" @change="onChange">
        <van-tab v-for="(item, index) in table" :key="index" :title="item"></van-tab>
      </van-tabs>
    </div>

    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="initData">

        <div v-for="(item, index) in list" :key="index">
          <img-text-exchange-order v-if="item.type == 0" :info="item"></img-text-exchange-order>
          <img-text-order v-else :info="item" @cancel_order="cancel_order"  @delete_order="delete_order" @confirm_order="confirm_order"></img-text-order>
        </div>
      </van-list>
    </div>

    <van-empty class="custom-image" v-if="list.length< 1" :image="noOrder" />

  </div>
</template>

<script>
import imgTextOrder from "@/components/img-text-order/img-text-order.vue";
import imgTextExchangeOrder from "@/components/img-text-exchange-order/img-text-exchange-order.vue";

export default {
  name: "OrderList",
  components: { imgTextOrder, imgTextExchangeOrder },
  props: {},
  data() {
    return {
      active: 0,
      pageNum: 1,
      pageSize: 10,
      state: "",
      table: ["全部", "未付款", "未发货", "待收货", "待评价"],
      list: [],

      loading: false,
      finished: false,

      noOrder:require('../../assets/public/no-order.png')
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.onChange(this.$route.query.tab);
  },
  methods: {
    // table切换
    onChange(event) {
      console.log(event, "实际table");
      this.active = event;
      this.loading = true;
      this.finished = false;
      this.list = [];
      this.pageNum = 1;
      this.state = event;

      this.initData();
    },
    // 初始化数据
    initData() {
      let _this = this;
      console.log(this.state);
      let data = {
        // type: 1,  //0：兑换订单，1：商城订单
        order_status: _this.state,
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      this.$post("/api/user_order_list", data, data).then((res) => {
        this.loading = false; // 加载状态结束
        console.log(res.data.data, "订单列表");

        if (res.data.code == 0) {
          let lists = res.data.data;

          if (lists && lists.length > 0) {
            if (_this.pageNum == 1) {
              _this.list = lists;
            } else {
              _this.list = _this.list.concat(lists);
            }
            _this.pageNum++;

            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            this.finished = true; // 数据全部加载完成
          }
        } else {
          this.$toast.fail(res.data.message);
          this.finished = true;
        }
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    // 取消
    cancel_order(info) {
      console.log(info, "取消成功！");
      let _this = this;
      let data = {
        order_sn: info.order_sn,
      };
      this.$post("/api/cancel_order", data, data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          this.$notify({ type: "success", message: "取消成功！" });
          this.loading = true;
          this.finished = false;
          this.list = [];
          this.pageNum = 1;
          this.initData();
        }else{
          this.$notify({ type: "danger", message: res.data.message || "稍后重试！" });
        }
      });
    },
    // 删除
    delete_order(info) {
      console.log(info, "删除成功！");
      let _this = this;
      let data = {
        order_sn: info.order_sn,
      };
      this.$post("/api/del_order", data, data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          this.$notify({ type: "success", message: "删除成功！" });
          this.loading = true;
          this.finished = false;
          this.list = [];
          this.pageNum = 1;
          this.initData();
        }else{
          this.$notify({ type: "danger", message: res.data.message || "稍后重试！" });
        }
      });
    },
    // 确认收货
    confirm_order(info) {
      console.log(info, "暂无法确认收货！");
      this.$notify({ type: "danger", message: "暂无法确认收货！" });
    //   let _this = this;
    //   let data = {
    //     order_sn: info.order_sn,
    //   };
    //   this.$post("/api/del_order", data, data).then((res) => {
    //     console.log(res);
    //     if (res.data.code == 0) {
    //       this.$notify({ type: "success", message: "删除成功！" });
    //       this.loading = true;
    //       this.finished = false;
    //       this.list = [];
    //       this.pageNum = 1;
    //       this.initData();
    //     }
    //   });
    },

  },
};
</script> 

<style lang="scss">
.order-list-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style>

<style lang="scss" scoped>
.tabs {
  position: fixed;
  /* top: 30rpx; */
  background-color: #fff;
  top: 46px;
  left: 0;
  width: 100%;
  z-index: 100;
}
.order-list-page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding: 96px 0 0;
  box-sizing: border-box;

  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */

  .list {
    padding: 0 10px 10px;
    box-sizing: border-box;
  }
}
</style>

 